import { useState } from "react";
import { toast } from "sonner";
import { Plus, Pencil, Trash2, Tags } from "lucide-react";
import { api } from "../../lib/api";
import { inputCls, errMsg, useCategories } from "./shared";

export default function CategoryManager() {
  const [cats, load] = useCategories();
  const [form, setForm] = useState({ name_hi: "", name_en: "" });
  const [editing, setEditing] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    try {
      if (editing) {
        await api.put(`/admin/categories/${editing}`, form);
        toast.success("श्रेणी अपडेट हुई");
      } else {
        await api.post("/admin/categories", form);
        toast.success("श्रेणी जोड़ी गई");
      }
      setForm({ name_hi: "", name_en: "" });
      setEditing(null);
      load();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  const remove = async (id) => {
    if (!window.confirm("क्या आप यह श्रेणी हटाना चाहते हैं?")) return;
    try {
      await api.delete(`/admin/categories/${id}`);
      load();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  return (
    <div>
      <form data-testid="category-form" onSubmit={submit} className="bg-white rounded-2xl border border-ngo-deep/10 p-6 grid sm:grid-cols-[1fr_1fr_auto] gap-4 mb-8 items-end">
        <div>
          <label className="text-xs font-semibold text-ngo-ink/60 block mb-1.5">श्रेणी नाम (हिंदी) *</label>
          <input data-testid="category-name-hi" required className={inputCls} value={form.name_hi} onChange={(e) => setForm({ ...form, name_hi: e.target.value })} />
        </div>
        <div>
          <label className="text-xs font-semibold text-ngo-ink/60 block mb-1.5">श्रेणी नाम (English)</label>
          <input data-testid="category-name-en" className={inputCls} value={form.name_en} onChange={(e) => setForm({ ...form, name_en: e.target.value })} />
        </div>
        <button data-testid="category-submit" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-ngo-deep text-white font-bold hover:bg-ngo-forest transition-colors duration-300">
          <Plus size={16} /> {editing ? "अपडेट करें" : "जोड़ें"}
        </button>
      </form>
      {editing && (
        <button onClick={() => { setEditing(null); setForm({ name_hi: "", name_en: "" }); }} className="mb-6 text-sm text-ngo-deep underline">संपादन रद्द करें</button>
      )}
      <div data-testid="category-list" className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {cats.map((c) => (
          <div key={c.id} className="bg-white rounded-2xl border border-ngo-deep/10 p-5 flex items-center justify-between gap-3">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-ngo-mint flex items-center justify-center text-ngo-deep"><Tags size={17} /></div>
              <div>
                <p className="font-semibold text-ngo-ink text-sm">{c.name_hi}</p>
                <p className="text-xs text-ngo-ink/50">{c.name_en || c.slug}</p>
              </div>
            </div>
            <div className="flex gap-1.5">
              <button data-testid={`category-edit-${c.slug}`} onClick={() => { setEditing(c.id); setForm({ name_hi: c.name_hi, name_en: c.name_en }); }} aria-label="संपादित करें" className="w-8 h-8 rounded-full bg-ngo-mint text-ngo-deep flex items-center justify-center hover:bg-ngo-leaf/25 transition-colors duration-200">
                <Pencil size={13} />
              </button>
              <button data-testid={`category-delete-${c.slug}`} onClick={() => remove(c.id)} aria-label="हटाएं" className="w-8 h-8 rounded-full bg-red-50 text-red-600 flex items-center justify-center hover:bg-red-100 transition-colors duration-200">
                <Trash2 size={13} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
